import { Component } from '@angular/core';

@Component({
  selector: 'app-conversion-largo-plazo',
  template: '<span></span>'
})
export class ConversionLargoPlazoComponent {
  public modelo: any = {};
}
